import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import {
  Layout,
  Breadcrumb,
  Form,
  Input,
  Table,
  Divider,
  List,
  Avatar,
  Select,
  Button,
  Tag,
  Tabs,
  DatePicker,
  Icon,
  Switch,
  message,
} from 'antd';
import {
  SearchOutlined,
  CopyOutlined,
  FormOutlined,
  ShopOutlined,
} from '@ant-design/icons';
import _ from 'lodash';
import './styles.module.scss';
import { API_HOST } from '../../configs/env';
import whttp from '../../libs/whttp';
import axios from 'axios';
import buildURL from 'axios/lib/helpers/buildURL';
import DeleteConfirmButton from 'components/DeleteConfirmButton/DeleteConfirmButton';
import { genFormItemAtrribute } from 'libs/FormHelper';
import AppHelper from 'libs/AppHelper';

const FormItem = Form.Item;

export default class CategoryList extends Component {
  formRef = React.createRef();
  state = {
    tableData: {
      current: 0, //目前頁數
      page_size: 10, //一頁幾筆
      total: 0, //以此query條件，總共幾筆資料
      rows: [],
    },
    table_query: {
      keyword: null,
      type: null,
    },
    message: '',
    keyword: '',
  };
  componentDidMount() {
    AppHelper.updateConfig();
    this.loadData();
  }
  // 拉Table資料
  loadData = (opt = { page: 1, page_size: 10 }) => {
    const { table_query } = this.state;
    const { page, page_size } = opt;
    this.setState({ isLoadingData: true });
    const tableQuery = this.formRef.current.getFieldValue();

    whttp.get(
      API_HOST + '/api/mgt/v1/categories',
      {
        page: page,
        page_size: page_size,
        keyword: _.get(tableQuery, 'keyword'),
        type: _.get(tableQuery, 'type'),
      },
      (state, res) => {
        this.setState({ isLoadingData: false });
        const { code = 100, reason = '發生錯誤', data = {} } = res;

        if (state === false) {
          return this.setState({ message: '發生錯誤' });
        }

        if (code !== 200) {
          return this.setState({ message: reason });
        }

        this.setState({ tableData: data });
      }
    );
  };

  // 匯出
  exportData = () => {
    const { table_query } = this.state;

    this.setState({ isExportData: true });
    axios({
      url: buildURL(API_HOST + '/api/mgt/v1/categories/export', {
        keyword: table_query.keyword,
        email: 'user@gmail.com',
        format: 'xlsx',
      }),
      method: 'GET',
      responseType: 'blob', // important
      headers: whttp.getHeaders(),
    })
      .then((response) => {
        this.setState({ isExportData: false });
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'export.xlsx');
        document.body.appendChild(link);
        link.click();
      })
      .catch((error) => {
        this.setState({ isExportData: false });

        let res = { code: 200, reason: '未知錯誤', error: error, data: {} };

        if (error.response) {
          res.code = error.response.status;
          res.reason = error.response.statusText;
        }

        message.warning('無法匯出:' + error.message);
      });
  };

  deleteData = (item) => {
    if (_.isNil(item.id)) return;
    item.isDeleteData = true;
    this.setState({ isDeleteData: true });

    whttp.delete(
      API_HOST + `/api/mgt/v1/categories/${item.id}`,
      {},
      (state, res) => {
        item.isDeleteData = false;
        this.setState({ isDeleteData: false });
        const { code = 100, reason = '發生錯誤', data = {} } = res;

        if (state === false) {
          return message.error('發生錯誤');
        }

        if (code !== 200) {
          return message.error(reason);
        }

        message.success('刪除成功');

        this.loadData();
      }
    );
  };

  cloneData = (item) => {
    if (_.isNil(item.id)) return;

    item.isCloneData = true;

    this.setState({ isCloneData: true });

    whttp.post(
      API_HOST + `/api/mgt/v1/categories/${item.id}/clone`,
      {},
      (state, res) => {
        item.isCloneData = false;
        this.setState({ isCloneData: false });
        const { code = 100, reason = '發生錯誤', data = {} } = res;

        if (state === false) {
          return message.error('發生錯誤');
        }

        if (code !== 200) {
          return message.error(reason);
        }

        message.success('複製成功');

        if (!_.isNil(data.id))
          this.props.history.push(`/category/view/${data.id}`);
      }
    );
  };

  //變更使用者狀態
  submitUserStatusData = (status, user_id, callback = (result) => {}) => {
    this.setState({ isSubmitUserStatusData: true });

    whttp.post(
      API_HOST + `/api/v1/user/status/${user_id}`,
      {
        status: status,
      },
      (state, res) => {
        this.setState({ isSubmitUserStatusData: false });

        const { code = 100, reason = '發生錯誤', data = {} } = res;

        if (state === false) {
          callback(false);

          return message.warning('發生錯誤');
        }

        if (code !== 200) {
          callback(false);

          return message.warning(reason);
        }
        callback(true);
      }
    );
  };

  render() {
    const { table_query = {}, tableData = {} } = this.state;
    const {
      app: {
        options: { fields: optionFields = [] },
      },
    } = this.props;
    const permissions = _.get(this.props, 'auth.permissions', {});
    const CategoryDate = _.get(tableData, 'rows');
    const options = _.get(this, 'props.app.options', {});

    return (
      <Layout>
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to={`/category`}>類別管理</Link>
          </Breadcrumb.Item>
        </Breadcrumb>

        <h2>
          類別管理<span />
        </h2>

        <div className='block search'>
          {/*<h3>搜尋<span></span></h3>*/}
          <Form ref={this.formRef}>
            <div className='flexBox col_12'>
              <FormItem
                {...genFormItemAtrribute('keyword', '名稱')}
                label='名稱'
              >
                <Input placeholder='搜尋名稱' />
              </FormItem>
            </div>
            <Form.Item {...genFormItemAtrribute('type', '類別')}>
              <Select placeholder='請選擇搜尋類別'>
                <option value={null}>請選擇搜尋類別</option>
                {_.map(_.get(options, 'category_types', []), (item) => (
                  <Select.Option key={item.id} value={item.id}>
                    {item.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item style={{ textAlign: 'right' }}>
              <Button
                onClick={(event) => {
                  this.formRef.current.resetFields();
                  this.setState({ tableQuery: {} });
                  this.loadData();
                }}
              >
                取消
              </Button>

              <Button
                type='primary'
                style={{ marginLeft: 8 }}
                icon={<SearchOutlined />}
                onClick={(event) => this.loadData()}
              >
                搜尋
              </Button>
            </Form.Item>
          </Form>
        </div>

        <div className='toolbar'>
          <h3>
            類別列表<span />
          </h3>
          <Form layout='inline'>
            <Form.Item>
              <div className='flexBox'>
                {/* permissions['service:edit'] && <Button>權限按鈕</Button> */}
                <Link to={`/category/view`}>
                  <Button type='primary'>新增</Button>
                </Link>
              </div>
            </Form.Item>
          </Form>
        </div>

        <Table
          dataSource={tableData.rows}
          loading={this.state.isLoadingData}
          pagination={{
            current: _.get(tableData, 'current', []),
            total: _.get(tableData, 'total', 0),
            pageSize: _.get(tableData, 'page_size', 0),
            onChange: (page, page_size) => {
              this.loadData({ page: page, page_size: page_size });
            },
          }}
          columns={[
            { dataIndex: 'id', title: 'ID' },
            { dataIndex: 'type_name', title: '類別' },
            { dataIndex: 'name', title: '名稱' },
            { dataIndex: 'status_name', title: '狀態' },
            { dataIndex: 'sort', title: '排序' },
            { dataIndex: 'updated_at', title: '更新時間' },
            //{ dataIndex: ['modified_user','name'] , title: '異動者'},
            {
              title: 'Action',
              key: 'tools',
              width: 250,
              render: (text, record) => (
                <List
                  grid={{ gutter: 4, column: 3 }}
                  dataSource={[
                    <DeleteConfirmButton
                      loading={record.isDeleteData === true}
                      size='small'
                      onConfirm={() => this.deleteData(record)}
                    />,
                    <Button
                      type='default'
                      size='small'
                      icon={<CopyOutlined />}
                      loading={record.isCloneData === true}
                      onClick={() => this.cloneData(record)}
                    >
                      複製
                    </Button>,
                    <Link role='button' to={`/category/view/${record.id}`}>
                      <Button
                        type='default'
                        size='small'
                        icon={<FormOutlined />}
                      >
                        編輯
                      </Button>
                    </Link>,
                  ]}
                  renderItem={(item) => <List.Item>{item}</List.Item>}
                />
              ),
            },
          ]}
        />
      </Layout>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/Category/CategoryList.js